import EleUploadVideo from './EleUploadVideo'

if (window && window.Vue) {
  // 浏览器环境
  window.Vue.component(EleUploadVideo.name, EleUploadVideo)
}

export default EleUploadVideo
